import { createSlice } from '@reduxjs/toolkit';

import { getElhaghiyehHayeSadereh, printElhaghiyehMosaferati } from './action';
import { IElhaghiyehSaderehDetailState } from './model';

const initialState: IElhaghiyehSaderehDetailState = {
  elhaghiyehHayeSadereh: {
    loading: false,
    data: [],
  },
  print: {
    loading: false,
  },
};

export const elhaghiyehHayeSaderehSlice = createSlice({
  name: 'Mosaferati/elhaghiyehHayeSadereh',
  initialState,
  reducers: {
    clearElhaghiyehHayeSadereh: (state) => {
      state.elhaghiyehHayeSadereh = initialState.elhaghiyehHayeSadereh;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getElhaghiyehHayeSadereh.pending, (state) => {
        state.elhaghiyehHayeSadereh.loading = true;
      })
      .addCase(getElhaghiyehHayeSadereh.fulfilled, (state, action) => {
        state.elhaghiyehHayeSadereh.loading = false;
        state.elhaghiyehHayeSadereh.data = action.payload;
      })
      .addCase(getElhaghiyehHayeSadereh.rejected, (state) => {
        state.elhaghiyehHayeSadereh.loading = false;
      });
    builder
      .addCase(printElhaghiyehMosaferati.pending, (state) => {
        state.print.loading = true;
      })
      .addCase(printElhaghiyehMosaferati.fulfilled, (state) => {
        state.print.loading = false;
      })
      .addCase(printElhaghiyehMosaferati.rejected, (state) => {
        state.print.loading = false;
      });
  },
});

export const { clearElhaghiyehHayeSadereh } = elhaghiyehHayeSaderehSlice.actions;

export default elhaghiyehHayeSaderehSlice.reducer;
